/* Endless swipe for carousels: any list marked data-loop-track wraps from the last slide back to the first (and the reverse) while swiping or using the arrows. */
(function () {
  if (window.zvLoopCarousel) return;
  window.zvLoopCarousel = true;

  function makeClone(li) {
    var c = li.cloneNode(true);
    c.setAttribute('aria-hidden', 'true');
    c.setAttribute('data-loop-clone', '');
    c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
    c.querySelectorAll('a,button,input,select,textarea,iframe,[tabindex]').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
    return c;
  }

  function init(track) {
    if (track.hasAttribute('data-loop-ready')) return;
    var items = Array.prototype.filter.call(track.children, function (li) {
      return getComputedStyle(li).display !== 'none';
    });
    if (items.length < 2) return;
    track.setAttribute('data-loop-ready', '');

    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    items.forEach(function (li) { before.appendChild(makeClone(li)); });
    items.forEach(function (li) { after.appendChild(makeClone(li)); });
    track.insertBefore(before, track.firstChild);
    track.appendChild(after);

    var firstClone = track.firstElementChild;
    var firstReal = items[0];

    function setWidth() {
      return firstReal.offsetLeft - firstClone.offsetLeft;
    }
    function active() {
      return firstClone.offsetWidth > 0 && track.scrollWidth > track.clientWidth + 2;
    }
    function jump(left) {
      var prev = track.style.scrollBehavior;
      var prevSnap = track.style.scrollSnapType;
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
      track.scrollLeft = left;
      track.style.scrollSnapType = prevSnap;
      track.style.scrollBehavior = prev;
    }
    function normalize() {
      if (!active()) return;
      var w = setWidth();
      if (w <= 0) return;
      var x = track.scrollLeft;
      if (x < w - 2) jump(x + w);
      else if (x >= 2 * w - 2) jump(x - w);
    }

    if (active()) jump(setWidth());

    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(normalize, 140);
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!active()) return;
      var w = setWidth();
      if (track.scrollLeft < w - 2 || track.scrollLeft >= 2 * w - 2) jump(w);
    });
  }

  document.querySelectorAll('[data-loop-track]').forEach(init);
})();
